import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useEffect,
} from "react";

import song1 from "../assets/music/m1.mp3";
import song2 from "../assets/music/m2.mp3";
import m1 from "../assets/images/cargo.jpeg";

const MusicContext = createContext();

const playlist = [
  {
    src: song1,
    title: "Late Night Vibes",
    artist: "Store Beats",
    cover: m1, 
  },
  {
    src: song2,
    title: "Calm Flow",
    artist: "Jun Pulse",
    cover: m1,
  },
];


export function MusicProvider({ children }) {
  const audioRef = useRef(new Audio(playlist[0].src));
  const [index, setIndex] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [volume, setVolume] = useState(0.3);

  useEffect(() => {
    const audio = audioRef.current;
    audio.src = playlist[index].src;
    audio.volume = volume;

    const onLoaded = () => setDuration(audio.duration || 0);
    const onTime = () => setCurrentTime(audio.currentTime);
    const onEnd = () => next();

    audio.addEventListener("loadedmetadata", onLoaded);
    audio.addEventListener("timeupdate", onTime);
    audio.addEventListener("ended", onEnd);

    if (playing) audio.play();

    return () => {
      audio.removeEventListener("loadedmetadata", onLoaded);
      audio.removeEventListener("timeupdate", onTime);
      audio.removeEventListener("ended", onEnd);
    };
  }, [index]);

  const play = () => {
    audioRef.current.play();
    setPlaying(true);
  };

  const pause = () => {
    audioRef.current.pause();
    setPlaying(false);
  };

  const next = () => {
    setIndex((i) => (i + 1) % playlist.length);
    setPlaying(true);
  };

  const prev = () => {
    setIndex((i) => (i - 1 + playlist.length) % playlist.length);
    setPlaying(true);
  };

  const seek = (t) => {
    audioRef.current.currentTime = t;
    setCurrentTime(t);
  };

  const changeVolume = (v) => {
    audioRef.current.volume = v;
    setVolume(v);
  };

  return (
    <MusicContext.Provider
      value={{
        playing,
        play,
        pause,
        next,
        prev,
        duration,
        currentTime,
        seek,
        volume,
        changeVolume,
        currentSong: playlist[index], 
      }}
    >
      {children}
    </MusicContext.Provider>
  );
}


export const useMusic = () => useContext(MusicContext);
